import { getConversationApi as generatedApi } from '../generated/conversations/getConversation';

const conversationApi = generatedApi.enhanceEndpoints({
  endpoints: {
    getConversation: {
      providesTags: (_result, _error, { conversationId }) => [{ id: conversationId, type: 'Conversations' }],
    },
  },
});

export { conversationApi as getConversationApi };
